// Toplu Depo Atama penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.bulkWarehouseAssign';

export const bulkWarehouseAssignGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Toplu depo ataması nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Henüz hiçbir depoda kaydı olmayan ürünleri tek seferde bir depoya bağlarsınız. Böylece ürünler o deponun stok listesinde görünür ve depo işlemlerinde kullanılabilir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Toplu Depo Atama'),
    body: t(`${G}.regions.body`, 'Ürün sayısı ve depo'),
    footer: t(`${G}.regions.footer`, 'İptal / Depoya Ata'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Hangi ürünler atanır?'),
      text: t(`${G}.s1.text`, 'Stok listesinde ürünleri seçip "Depoya Ata (n)" düğmesine bastığınızda bu pencere açılır. "n ürün seçili depoya atanacak" satırındaki sayı, seçtikleriniz arasından hiçbir depoda kaydı olmayan ürünlerdir; zaten bir depoda olan ürünler atlanır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Seçtiklerinizin hepsi zaten bir depodaysa "Atanacak deposuz ürün bulunamadı" uyarısı çıkar ve işlem yapılmaz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Depoyu seçin'),
      text: t(`${G}.s2.text`, '"Depo Seçin" listesinden depoyu seçin. Adında "merkez" geçen depo "Önerilen" etiketiyle gösterilir ve kendiliğinden seçili gelir; yoksa ilk depo seçilir.'),
      tips: [
        t(`${G}.s2.tip1`, '"Hiç depo bulunamadı" yazıyorsa önce Depolar ekranından bir depo oluşturun.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Stok miktarı 0 olarak başlar'),
      text: t(`${G}.s3.text`, 'Ürünler depoya başlangıç miktarı 0 (sıfır) ile atanır; stok hareketi oluşmaz, mevcut stok değişmez. Sonra depo transferi ya da miktar güncellemesiyle stok ekleyebilirsiniz.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Depoya Ata'),
      text: t(`${G}.s4.text`, '"Depoya Ata" düğmesine basın; işlem sürerken "Ürünler depoya atanıyor..." yazar ve pencere kapatılamaz. Bitince "n ürün başarıyla depoya atandı!" mesajı çıkar, seçimler temizlenir ve liste yenilenir.'),
    },
  ],
});
